export const BOOKS_RETURN_DATES_ENDPOINT = "/books/return/dates";
export const BOOKS_ENDPOINT = "/books/all";
export const BOOKS_SCHOOL_ENDPOINT = "/books/school";
export const BOOKS_USER_ENDPOINT = "/books/user/all";
export const BOOKS_SAVEMARKS_ENDPOINT = "/books/save-marks/user";
export const BOOKS_IMAGES_ENDPOINT = "/books/images/art";
export const BOOKS_DISABLE_ENDPOINT = "/books/disable";
export const BOOKS_DISABLE_INVOICE_ENDPOINT = "/books/disableInvoice";
export const BOOKS_MULTIPLE_STATUS_ENDPOINT = "/books/set-multiple-book-status";
export const BOOKS_UPDATE_ENDPOINT = "/books/update";
export const BOOKS_UPDATE_MANY_ENDPOINT = "/books/update-many";
export const BOOKS_PROGRESS_RESET_ENDPOINT = "/books/progress/reset";
export const BOOKS_COMPLETE_ENDPOINT = "/books/complete";
export const BOOKS_SUMMARY_ENDPOINT = "/books/summary";
export const BOOKS_EMAIL_SUMMARY_ENDPOINT = "/books/email-summary";

export const SCHOOLS_ENDPOINT = "/schools/all";
export const SCHOOLS_SIMPLE_ENDPOINT = "/schools/simple-all";
export const SCHOOLS_MANAGER_ENDPOINT = "/schools/manager";
export const SCHOOLS_PETITION_ENDPOINT = "/schools/petition";
export const SCHOOLS_AND_USER_STATS_EXPORT_ENDPOINT =
  "/schools/export/schools-and-user/stats";
export const SCHOOLS_AND_USER_STATS_ENDPOINT =
  "/schools/schools-and-user/stats";
export const SCHOOLS_STATS_ENDPOINT = "/schools/schools/stats";
export const SCHOOLS_STUDENTS_STATS_ENDPOINT = "/schools/schools/users/stats";
export const SCHOOL_TYPES_ENDPOINT = "/schools/school-types";
export const SCHOOL_BYUSER_ENDPOINT = "/schools/simple-by-user";
export const SCHOOL_SETTINGS_ENDPOINT = "/Schools/settings";

export const USERS_ALL_ENDPOINT = "/account/all";
export const USERS_ENDPOINT = "/account/user";
export const STUDENTS_ALL_ENDPOINT = "/account/all/student";
export const ALL_ROLES_ENDPOINT = "/account/all/roles";
export const UPDATE_ROLES_ENDPOINT = "/account/update/roles";
export const ACCOUNT_UPDATE = "/account/update";
export const ACCOUNT_CHANGE_PASSWORD = "/account/changepassword";
export const ACCOUNT_CHANGE_NOTIFICATION = "/account/change-show-user-notification";

export const ACCOUNT_LOGIN_USER = "/account/login/user";
export const ACCOUNT_SIGN_OUT = "/account/signout";
export const ACCOUNT_LOGIN_EXTERNAL_USER = "/account/login/external-user";
export const ACCOUNT_LOGIN_STUDENT = "/account/login/student";
export const ACCOUNT_CURRENT = "/account/current";
export const ACCOUNT_ACTIVATE_ADVICE = "/account/activate-advice";
export const ACCOUNT_ACTIVATE_ADVICE_SCHOOL = "/account/activate-advice/school";

export const SCHOOL_RETURNS = "/barcodes/schoolPackages";
export const SCHOOL_RETURNS_BY_SCHOOL = "/barcodes/school-barcodes";
export const SCHOOL_RETURNS_BY_STUDENT = "/barcodes/barcode-books";

export const SCHOOL_CREATE_FLOW = "/barcodes/create/school-package";
export const SCHOOL_DELETE_FLOW = "/barcodes/delete/school-package";

export const SCHOOL_RETURNS_SCHOOL_UPDATE = "/barcodes/update/school-package";
export const SCHOOL_RETURNS_PACKAGE_UPDATE = "/barcodes/update/school-barcodes";
export const SCHOOL_RETURNS_BOOK_UPDATE = "/barcodes/update/barcode-book";

export const SCHOOL_RETURNS_SUMMARY_UPDATE = "/barcodes/barcode-books/summary";
export const SCHOOL_RETURNS_EXPORT = "/barcodes/barcode-books/export";

export const SCHOOL_BOOKS_PURCHASE = "/barcodes/schoolBookPackages";
export const SCHOOL_BOOKS_PURCHASE_UPDATE =
  "/barcodes/update/school-book-package";
export const SCHOOL_BOOKS_PURCHASE_SUMMARY =
  "/barcodes/school-book-package/summary";
export const SCHOOL_PURCHASE_FILE =
  "/barcodes/update/import-purchase-school-book-package";

export const LOGISTICS_ENDPOINT = "/logistics/all";
export const LOGISTICS_SAVE_MAP_ENDPOINT = "/logistics/save-map";
export const LOGISTICS_DISABLE_ENDPOINT = "/logistics/disable";
export const LOGISTICS_CHANGE_HAS_RETURN_MARK = "/logistics/change-has-return-mark";
export const DOWNLOAD_LOGISTICS_ENDPOINT = "/logistics/dowload-logistics-data";
export const AUTO_LINK_LOGISTICS_ENDPOINT = "/logistics/auto-link";
export const LOGISTICS_LINKBARCODE_ENDPOINT = "/logistics/link-to-barcode";
export const LOGISTICS_LINKBOOK_ENDPOINT = "/logistics/link-to-barcode-book";
export const LOGISTICS_UNLINKBARCODE_ENDPOINT =
  "/logistics/un-link-from-barcode";
export const LOGISTICS_DUPLICATELINES_ENDPOINT = "/logistics/duplicate-lines";
export const LOGISTICS_EXPORTPACKAGES_ENDPOINT = "/logistics/export";
export const LOGISTICS_WARNINGS_ENDPOINT = "/logistics/warnings";
export const LOGISTICS_STATISTICS_ENDPOINT = "/logistics/statistics";
export const LOGISTICS_LINK_RETURN_ENDPOINT =
  "/logistics/link-to-barcode-return";

export const PREREGISTRATION_STATUS_ENDPOINT =
  "/preregistration/status";
export const PREREGISTRATION_BOOKS_ENDPOINT =
  "/preregistration/books";
export const PREREGISTRATION_UPDATE_BOOKS_ENDPOINT =
  "/PreRegistration/updatebooks";
export const PREREGISTRATION_FINISH = "/PreRegistration/finish";
export const PREREGISTRATION_EXPORT_VERIFIED = "/PreRegistration/ExportFilePreRegCompleted";
export const PREREGISTRATION_SCHOOL_ENDPOINT =
  "/PreRegistration/dashboard/schools";
export const PREREGISTRATION_DASHBOARD_ENDPOINT =
  "/PreRegistration/dashboard";
export const PREREGISTRATION_DASHBOARD_REFRESH_ENDPOINT =
  "/PreRegistration/dashboard/refresh";
export const PREREGISTRATION_DASHBOARD_SCHOOL_ENDPOINT =
  "/PreRegistration/dashboard/school";
export const PREREGISTRATION_DASHBOARD_SCHOOL_REFRESH_ENDPOINT =
  "/PreRegistration/dashboard/refresh/school";
export const RETURNS_ALL = "/returns/all";

export const SCHOOL_SET_BOOK_STATUS = "/schools/set-book-status";
export const ALL_SCHOOL_SET_BOOK_STATUS = "/schools/all/set-book-status";
